import React from "react";
import PropTypes from "prop-types";


const Add = ({onClick, disabled, title}) => (
  <div>
    <button
      className="btn btn-pink btn-raised btn-long"
      onClick={onClick}
      disabled={disabled}
      title={title}
    >
      ADD
    </button>
  </div>
);


Add.propTypes = {
  onClick: PropTypes.func
};

export default Add;
